import React from 'react';
import { useTranslation } from 'react-i18next';

type MadeInIndiaBadgeProps = {
  size?: 'sm' | 'md';
  variant?: 'pill' | 'subtle';
  className?: string;
  showTagline?: boolean;
};

export function IndianFlagIcon({
  className = '',
  width = 20,
}: {
  className?: string;
  width?: number;
}) {
  const height = Math.round(width * (2 / 3));
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 16"
      role="img"
      aria-label="Indian flag"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="5.34" fill="#FF9933" />
      <rect y="5.33" width="24" height="5.34" fill="#FFFFFF" />
      <rect y="10.66" width="24" height="5.34" fill="#138808" />
      <circle cx="12" cy="8" r="2.1" fill="none" stroke="#000080" strokeWidth="0.55" />
      <circle cx="12" cy="8" r="0.45" fill="#000080" />
      {Array.from({ length: 12 }, (_, i) => {
        const angle = (i * 30 * Math.PI) / 180;
        const x2 = 12 + Math.cos(angle) * 1.65;
        const y2 = 8 + Math.sin(angle) * 1.65;
        return (
          <line
            key={i}
            x1="12"
            y1="8"
            x2={x2}
            y2={y2}
            stroke="#000080"
            strokeWidth="0.28"
          />
        );
      })}
    </svg>
  );
}

const MadeInIndiaBadge: React.FC<MadeInIndiaBadgeProps> = ({
  size = 'md',
  variant = 'pill',
  className = '',
  showTagline = false,
}) => {
  const { t } = useTranslation();
  const flagWidth = size === 'sm' ? 18 : 22;

  return (
    <span
      className={[
        'made-in-india-badge',
        `made-in-india-badge--${size}`,
        `made-in-india-badge--${variant}`,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <IndianFlagIcon width={flagWidth} className="made-in-india-badge__flag shrink-0" />
      <span className="made-in-india-badge__text">
        <span className="made-in-india-badge__label">{t('footer.madeInIndia')}</span>
        {showTagline ? (
          <span className="made-in-india-badge__tagline">
            {t('home.hero.madeInIndiaTagline', 'Proudly built for Indian job seekers')}
          </span>
        ) : null}
      </span>
    </span>
  );
};

export default React.memo(MadeInIndiaBadge);
